import {Component, OnInit} from "@angular/core";
import {Router} from '@angular/router';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {User} from '../common/user';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {ErrorService} from '../common/error.service';
import {ConfirmDialogService} from '../common/confirm-dialog/confirm-dialog.service';
import {passwordSuccessMessages, UserAuthenticationService} from '../common/user-authentication.service';
import {connectApi} from "../common/connect-api";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AllValidationErrors, getFormValidationErrors} from "../common/get-form-validation-errors";
import {NotificationService} from '../common/notification/notification.service';

@Component({
    selector: 'dp-connect-forgot-password',
    templateUrl: 'forgot-password.component.html',
    providers: [UserAuthenticationService]
})
export class ForgotPasswordComponent implements OnInit {
    routerState: any;
    loginId: string;
    formGroup : FormGroup;
    emailConfirmationSent: boolean = false;
    resetLinkSent: string = passwordSuccessMessages.resetLinkSent;
    resetLinkSent2: string = passwordSuccessMessages.resetLinkSent2;

    constructor(private  router: Router,
                private userAuthenticationService: UserAuthenticationService,
                private confirmDialogService: ConfirmDialogService,
                ) {
        this.routerState = (this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras) ?
            this.router.getCurrentNavigation().extras.state :
            undefined;
    }

    ngOnInit() {
        if (this.routerState && this.routerState.loginId) {
            this.loginId = this.routerState.loginId;
        }
        this.formGroup = new FormGroup({
            'loginId' : new FormControl(!!this.loginId ? this.loginId : '',Validators.email)
        })
    }

    submit(): void {
        const errors: AllValidationErrors[] = getFormValidationErrors(this.formGroup.controls);
        if(errors.length == 0) {
            this.userAuthenticationService.requestPasswordResetLink(this.formGroup.value.loginId).subscribe(
                (res: User) => {
                    if (res) {
                        this.emailConfirmationSent = true;
                        //const msg: string = passwordSuccessMessages.resetLinkSent;
                        //this.notificationService.showNotification(msg,'success');
                    }
                }
            );
        }
    }

    isResetPassword(): boolean {
        return this.routerState && this.routerState.resetPassword;
    }
}
